import { Serializable } from './commom/serializable';

export class Empresa implements Serializable<Empresa> {
    public Id: number;
    public Descricao: string;

    deserialize(input: Object): Empresa {
        Object.assign(this, input);

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/entities/empresa.ts